import {Declension} from "../declension/declension";

$(function() {
    initFavorites();
});

function initFavorites()
{
    checkFavoritesLink();

    $(document).off('click').on('click', '.like, [data-card-favorite]', function(e) {
        e.preventDefault();

        let _this = $(this);

        let _id = _this.data('id');
        _id = parseInt(_id);

        let _profile = _this.hasClass('js-favorite-profile');
        let _profileMulti = _this.hasClass('js-favorite-profile-multi');

        let data = {
            id: _id,
        }

        if ($('[data-preloader]').length > 0) {
            $('[data-preloader]').show();
        }

        if (
            window.window.xhr_add_favorite
            && (window.window.xhr_add_favorite.readyState !== 4)
        ) {
            window.window.xhr_add_favorite.abort();
        }

        window.xhr_add_favorite = $.post(
            '/local/ajax/favorites.php',
            data,
                function(response) {
                if (!window.favorites) {
                    window.favorites = [];
                }

                if (response.status === 'ok') {
                    window.favorites = response.data || [];

                    checkFavoritesLink();

                    $(this).toggleClass('active');

                    if (_profile) {
                        getLastItem();
                    } else if (_profileMulti) {
                        let declension = new Declension();

                        $('[data-count-favorites-list]').text(
                            window.favorites.length + ' ' + declension.declension(window.favorites.length, ['товар', 'товара', 'товаров'])
                        );

                        if ($('[data-preloader]').length > 0) {
                            $('[data-preloader]').hide();
                        }
                    } else {
                        if ($('[data-preloader]').length > 0) {
                            $('[data-preloader]').hide();
                        }
                    }
                } else {
                    $.magnificPopup.open({
                        items: {
                            src: '#popup-error'
                        },
                        type: 'inline',
                        midClick: true,
                        closeMarkup: '<button title="%title%" type="button" class="mfp-close popup__close close"></button>',
                        removalDelay: 500, //delay removal by X to allow out-animation
                        callbacks: {
                            beforeOpen: function() {
                                this.st.mainClass = 'mfp-right-left';
                            }
                        }
                    });

                    if ($('[data-preloader]').length > 0) {
                        $('[data-preloader]').hide();
                    }
                }
            },
            'json'
        );
    });
}

function checkFavoritesLink()
{
    var favCount = $('.fav-count');

    if (!window.favorites) {
        window.favorites = [];
    }

    favCount.html(window.favorites.length);

    if (window.favorites.length > 0) {
        favCount.show();
    } else {
        favCount.hide();
    }

    $('.like, [data-card-favorite]').each(function() {
        let _id = $(this).data('id');
        _id = parseInt(_id);

        if (window.favorites.indexOf(_id) > -1) {
            $(this)
                .addClass('active')
                .attr('title', BX.message('PM_CATALOG_ELEMENT_FAVORITES_REMOVE'))
                .attr('value', BX.message('PM_CATALOG_ELEMENT_FAVORITES_REMOVE'));

            $(this).find('span').text(BX.message('PM_CATALOG_ELEMENT_FAVORITES_IN'));
        } else {
            $(this)
                .removeClass('active')
                .attr('title', BX.message('PM_CATALOG_ELEMENT_FAVORITES_ADD'))
                .attr('value', BX.message('PM_CATALOG_ELEMENT_FAVORITES_ADD'));

            $(this).find('span').text(BX.message('PM_CATALOG_ELEMENT_FAVORITES_ADD'));

            hideFavoritesItem(_id);
        }
    });
}


function hideFavoritesItem(id)
{
    var itemBlock = $('.favorites-block').find('.complect-item-block[data-id=' + id + ']');
    itemBlock.remove();
}

function getLastItem()
{
    if (
        window.xhr_favorite_last
        && (window.xhr_favorite_last.readyState !== 4)
    ) {
        window.xhr_favorite_last.abort();
    }

    window.xhr_favorite_last = $.post(
        '/local/ajax/favorite_last.php',
        function(_res) {
            let favProfile = $('.favorites-profile');

            favProfile.append(_res['favItem'])

            let img = favProfile.find('.lazyload');
            let lazy = new LazyLoad(img);

            lazy.loadImages();

            if ($('[data-preloader]').length > 0) {
                $('[data-preloader]').hide();
            }
        },
        'json'
    );
}
